export * from "./InputColor";
